import React from 'react';
import { Breadcrumbs, Link, Typography } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useNavigate } from 'react-router-dom';

/**
 * items: Array<{ label: string, path?: string }>
 * Last item is the current page (no link).
 */
const AppBreadcrumbs = ({ items = [] }) => {
  const navigate = useNavigate();

  return (
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="small" />}
      aria-label="breadcrumb"
      sx={{ mb: 2 }}
    >
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return isLast ? (
          <Typography
            key={index}
            variant="body2"
            color="text.primary"
            fontWeight={600}
            sx={{ letterSpacing: '-0.01em' }}
          >
            {item.label}
          </Typography>
        ) : (
          <Link
            key={index}
            underline="hover"
            color="text.secondary"
            sx={{
              cursor: 'pointer',
              typography: 'body2',
              fontWeight: 500,
            }}
            onClick={() => {
              if (!item.path) return;
              const p = String(item.path);
              navigate(p.startsWith('/') ? p : `/${p}`);
            }}
          >
            {item.label}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
};

export default AppBreadcrumbs;
